export default __webpack_public_path__ + "static/media/type-h2.79f13fc5.svg";